import { NgModule } from '@angular/core';
import { ClothingStoreService } from './clothing-store.service';

@NgModule({
  imports: [],
  providers: [ClothingStoreService],
  exports: [],
})
export class ClothingStoreModule {}
